import PropTypes from 'prop-types';

import { FormField, Label, LabeledControl, Paragraph, Radio, Textarea } from '@zillow/constellation-10';

import { RADIO_OPTIONS } from '../constants';

const propTypes = {
  selectedReasonKey: PropTypes.string,
  setSelectedReasonKey: PropTypes.func.isRequired,
  listingIssueReason: PropTypes.string,
  setListingIssueReason: PropTypes.func.isRequired,
};
const defaultProps = {
  selectedReasonKey: '',
  listingIssueReason: '',
};

const ScheduleDeactivation = ({
  selectedReasonKey,
  setSelectedReasonKey,
  listingIssueReason,
  setListingIssueReason,
}) => (
  <>
    <Paragraph textStyle="heading-sm" css={{ marginBottom: '400' }}>
      The listing will no longer be advertised. Please choose your reason for deactivating it.
    </Paragraph>

    <FormField>
      {Object.entries(RADIO_OPTIONS).map((obj) => (
        <LabeledControl
          key={obj[0]}
          controlId={obj[0]}
          labelPosition="right"
          label={<Label>{obj[1].displayLabel}</Label>}
          control={
            <Radio name={obj[0]} checked={selectedReasonKey === obj[0]} onChange={() => setSelectedReasonKey(obj[0])} />
          }
        />
      ))}
      {selectedReasonKey === 'HAS_ERROR' && (
        <Textarea
          css={{ marginBottom: '400' }}
          maxLength="850"
          placeholder="Enter the listing issue"
          value={listingIssueReason}
          onChange={(e) => setListingIssueReason(e.target.value)}
        />
      )}
    </FormField>
  </>
);

ScheduleDeactivation.propTypes = propTypes;
ScheduleDeactivation.defaultProps = defaultProps;

export default ScheduleDeactivation;
